import firebase_api from '@/firebase/firebase_api'
const object = {
    sendEmail(emailUser, idMail, params) {
        firebase_api.api.getDb().collection("admin_email").doc(idMail).get().then(emailDoc=>{
            
            var email = emailDoc.data();
            if (email.enabled) {
                var html = email.html;
                var subject = email.subject;
                var values = email.values.split(",");
                values.forEach(value => {
                    html = html.split("%"+value).join(params[value]);
                });
                var mailRef =  firebase_api.api.getDb().collection('mail');
                mailRef.add(
                    {
                        to: emailUser,
                        message: {
                        subject: subject,
                        html: html
                        },
                        group: idMail
                    })    
            }
        })

    },
    async sendEmailByBatch(batch, emailUser, idMail, params) {
        var emailDoc = await firebase_api.api.getDb().collection("admin_email").doc(idMail).get();
            
        var email = emailDoc.data();
        if (email.enabled) {
            var html = email.html;
            var subject = email.subject;
            var values = email.values.split(",");
            values.forEach(value => {
                html = html.split("%"+value).join(params[value]);
                //html = html.replaceAll("%"+value, params[value]);
            });
            var mailRef =  firebase_api.api.getDb().collection('mail');
            var mailDoc= mailRef.doc();
            var mailId = mailDoc.id;
            mailRef =  mailRef.doc(mailId);
            batch.set(mailRef,
            {
                to: emailUser,
                message: {
                    subject: subject,
                    html: html
                },
                group: idMail
            })  
        }
    },
    parse(str) {
        return str.replace(str, () => args[i++]);
    },
}


export default {
	object: object
}